import { defaultRegionInfoProvider } from "./endpoints";
import { parseUrl } from "@aws-sdk/url-parser";
/**
 * @internal
 */
export var getRuntimeConfig = function (config) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (config === void 0) { config = {}; }
    return ({
        apiVersion: "2006-03-01",
        disableHostPrefix: (_a = config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config.regionInfoProvider) !== null && _c !== void 0 ? _c : defaultRegionInfoProvider,
        serviceId: (_d = config.serviceId) !== null && _d !== void 0 ? _d : "S3",
        signingEscapePath: (_e = config.signingEscapePath) !== null && _e !== void 0 ? _e : false,
        urlParser: (_f = config.urlParser) !== null && _f !== void 0 ? _f : parseUrl,
        useArnRegion: (_g = config.useArnRegion) !== null && _g !== void 0 ? _g : false,
    });
};
//# sourceMappingURL=runtimeConfig.shared.js.map